//3rd Party Components
import React, { Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import MetaTags from 'react-meta-tags';

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import Heading from '../components/CASA/Heading';
import Container from '../components/CASA/Container';

//Actions and Selectors
import { getParamValue, IsVerifiedUserWithARN, getUserHomePage, CanUserSelectProfile, UserMustSubmitIndividualARNApplication, UserMustVerifyPOI, urlSearchValue } from '../components/Portal/Utilities';
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getAddressDetailsOrganisation, FETCH_ADDRESSDETAILSORGANISATION_SUCCESS } from '../PortalStore/Actions/AddressDetailsOrganisationActions';
import { getOrgDetailsSelector } from '../PortalStore/Selectors/OrgDetailsSelectors';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';

export const ProfileDetailsOrgPage = () => {
    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let userdetails = useSelector(state => state.userdetails);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let addressdetailsOrganisation = useSelector(state => state.addressdetailsOrganisation);
    let urlAEM = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlUpdateUser = useSelector(state => getUrlSelector(state, "Portal - AEM Update User Details URL"));

    let urlUpdateAddress = useSelector(state => getUrlSelector(state, "Portal - AEM Address Update URL"));
    let urlUpdatePhone = useSelector(state => getUrlSelector(state, "Portal - AEM Phone Update URL"));

    let name = useSelector(state => getOrgDetailsSelector(state, "name"));
    let phone = useSelector(state => getOrgDetailsSelector(state, "telephone1"));
    let email = useSelector(state => getOrgDetailsSelector(state, "emailaddress1"));
    let orgarn = useSelector(state => getOrgDetailsSelector(state, "casa_arn"));

    let organisationId = urlSearchValue('casaorgid');
    if (organisationId === null) {
        organisationId = getParamValue('organisationId');
    }

    useEffect(() => {
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;

        axios.all([
            dispatch(getAddressDetailsOrganisation(webappurl, accessToken, organisationId))
        ])
            .then(axios.spread((addrdetailsres) => {
                if (addrdetailsres.type === FETCH_ADDRESSDETAILSORGANISATION_SUCCESS) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("PDI.1");
                    setPageLoaded(true);

                    var msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    var details = "Details: PDO.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("PDO.1");
                setPageLoaded(true);

                dispatch(addPageAlert({ level: "error", title: "System error PDO.1" }));
            });
        
    }, []);

    const showSpinner = () => {
        if (!pageLoadedError) {
            return (<CASASpinner message="Working. Please wait....." />)
        }
        else {
            return null;
        }
    }

    const showPostal = (postal) => {
        if (postal)
            return (<span><br /><strong>Postal: </strong><br />{postal}</span>);
        else
            return null;
    }

    const showStreet = (street1, street2, street3, street4, street5) => {
        return (
            <div>
                {street1 !== '' ? { street1 } : ""}
                {street1 !== '' ? <br/> : ""}
                {street2 !== '' ? { street2 } : ""}
                {street2 !== '' ? <br /> : ""}
                {street3 !== '' ? { street3 } : ""}
                {street3 !== '' ? <br /> : ""}
                {street4 !== '' ? { street4 } : ""}
                {street4 !== '' ? <br /> : ""}
                {street5 !== '' ? { street5 } : ""}
                {street5 !== '' ? <br /> : ""}
            </div>
        )
    }

    const findByOrgId = (val) => {
        return (val.orgid === this);
    }

    const navigateAEMUpdateDetails = () => {
        var crumbs = [
            {
                link: userHomePage,
                text: 'myCASA'
            },
            {
                link: "/forms/profiledetailsorg?standalone=" + standalone,
                text: 'Profile'
            }
        ];
        var params = {
            'breadcrumbs': crumbs
        };

        if (participants.hasParticipants) {
            params.showProfileSelector = 1;
        }
        const aemnav = urlAEM + urlUpdateUser + "?" + encodeURIComponent(btoa(JSON.stringify(params)));

        return aemnav;
    }

    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);

    if (UserMustSubmitIndividualARNApplication(userHomePage) || UserMustVerifyPOI(userHomePage)) {
        history.push(userHomePage);
    }
    else {

        let jparams = {
            organisationId: organisationId
        }

        const showItems = true;

        const items = [
            {
                text: 'myCASA',
                link: '/forms/dashorg?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))
            },
            {
                text: 'Profile'
            }
        ];

        if (!pageLoaded) {
            return (
                <Fragment>
                    <MetaTags>
                        <title>Organisation Profile Details</title>
                    </MetaTags>

                    <div className="row">
                        <div className="col-sm-12">
                            <Heading
                                text="Profile"
                                breadcrumbs={items}
                                showcrumbs={showItems}
                                showback={false} />
                        </div>
                    </div>

                    <Container show={true}>
                    </Container>

                    {showSpinner()}

                </Fragment>)

        }
        else {
            let details = addressdetailsOrganisation.items.value[0];
            let street = '';
            let street1 = '';
            let street2 = '';
            let street3 = '';
            let street4 = '';
            let street5 = '';
            let postal = '';
            let postal1 = '';
            let postal2 = '';
            let postal3 = '';
            let postal4 = '';
            let postal5 = '';

            street1 = (details.address1_line3 || "") + (details.casa_address1_extraline || "") + (details.address1_line1 || "") + (details.address1_line2 || "");

            street1 = street1.trim();
            street3 = (details.address1_city || "").trim();

            street4 = (details.address1_stateorprovince || "").trim() + (details.address1_postalcode || "");
            street4 = street4.trim();

            street5 = (details.address1_country || "").trim();


            postal1 = (details.address2_line3 || "").trim() + (details.casa_address2_extraline || "").trim() + (details.address2_line1 || "").trim() + (details.address2_line2 || "").trim();
            postal1 = postal1.trim();

            postal2 = (details.casa_address2_building || "").trim();

            postal3 = (details.address2_city || "").trim();

            postal4 = (details.address2_stateorprovince || "").trim() + (details.address2_postalcode || "");
            postal4 = (postal4 || "").trim();

            postal5 = (details.address2_country || "").trim();
            let postalSize = postal1.length + postal2.length + postal3.length + postal4.length + postal5.length;

            if (postal1 !== '') postal1 = <div>postal1<br /></div>;
            if (postal2 !== '') postal2 = postal2 + '<br>';
            if (postal3 !== '') postal3 = postal3 + '<br>';
            if (postal4 !== '') postal4 = postal4 + '<br>';
            if (postal5 !== '') postal5 = postal5 + '<br>';

            if (street === postal) {
                postal = <div>Same as Residential.<br /></div>;
            }

            let participant = participants.items.participantsAll.find(findByOrgId, organisationId);
            let roles = "";
            if (participant != null) {
                roles = participant["role.casa_name"];
            }

            return (
                <Fragment>
                    <MetaTags>
                        <title>Organisation Profile Details</title>
                    </MetaTags>

                    <div className="row">
                        <div className="col-sm-12">
                            <Heading
                                text="Profile"
                                breadcrumbs={items}
                                showcrumbs={showItems}
                                showback={false} />
                        </div>
                    </div>

                    <br />
                    <div className="row">
                        <div className="col-sm-12">
                            <h2 className="au-display-md">Organisation details</h2>
                            <strong>Name: </strong>{name}
                            <br />
                            <strong>ARN: </strong>{orgarn}
                            <br />
                            <h2 className="au-display-md">Contact details</h2>
                            <strong>Email: </strong>{email}

                            {roles.includes('Chief Executive Officer') || roles.includes('Authorised Representative') ? <a id="emailupdate" href={urlUpdateAddress}>Update email address</a> : ""}

                            <br />
                            <strong>Phone: </strong>{phone}

                            {roles.includes('Chief Executive Officer') || roles.includes('Authorised Representative') ? <a id="phoneupdate" href={urlUpdatePhone}>Update phone number</a> : ""}

                            <br />
                            <h2 className="au-display-md">Address details</h2>
                            <strong>Business:</strong>
                            <br />

                            {showStreet(street1, street2, street3, street4, street5)}

                            {postalSize !== 25 ? showPostal(postal) : ""};

                            <br />
                            <p>
                                {roles.includes('Chief Executive Officer') || roles.includes('Authorised Representative') ? <a href={navigateAEMUpdateDetails()}>Update your details</a> : ""}
                            </p>
                        </div>
                    </div>

                    <br />


                </Fragment>
            );
        }

    }

}
